<template>
  <app>
    <template v-slot:languageSelection>
      <language-selection />
    </template>
    <template v-slot:content>
      <router-view />
    </template>
  </app>
</template>

<script>
const App = () => import(/* webpackChunkName: "AboutMePage" */ "@/App.vue");
const LanguageSelection = () =>
  import(/* webpackChunkName: "AboutMePage" */ "@/components/Global/LanguageSelection.vue");

export default {
  name: "AboutMeApp",
  components: {
    App,
    LanguageSelection
  }
};
</script>
